/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { adCustomizersStyle } from './style/styles';

/** Picker for ad customizer
 * all editor are on top of this
 * it will do following things
 *  1 show syntax when syntax is not null
 *  2 show editor when editorView not null
 *  3 show the selectable items when itemsToDisplay not empty and editorview null
 *  @param {number} props - analyzer index
 *  @returns {Object} PickerEditorContainer
 */
export function AdCustomizerPickerEditorContainer(props) {
  const classes = useDefaultStyles(adCustomizersStyle);

  // eslint-disable-next-line arrow-body-style
  const getDisplayPosition = (target, container) => {
    // Calculate the position of the popup relative to the container.
    // The container needs to be non-statically positioned, either fixed, relative or absolute,
    // because the popup is position: absolute.
    const targetRect = target.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    return {
      top: (targetRect.bottom - containerRect.top) + 1,
      left: targetRect.left - containerRect.left - 1,
    };
  };


  const {
    target,
    editorView,
    syntax,
    itemsToDisplay,
    adType,
    activity,
    container,
  } = props;
  const position = getDisplayPosition(target, container);

  const containerStyle = { display: 'block', left: `${position.left}px`, top: `${position.top}px` };
  let syntaxToUse = null;

  if (syntax) {
    syntaxToUse = (
      <div className="adcustomizerpicker-syntax-container">
        {syntax}
      </div>);
  }

  let contentView = null;
  let contentClasses = [];

  if (editorView) {
    contentView = (<div className="picker-content">{editorView}</div>);
    contentClasses = ['adCustomizersEditor'];
  } else {
    contentClasses = ['picker-list'];
    contentView = itemsToDisplay.map(({ name, description, onClick }, index) => {
      const updatedOnClick = (event) => {
        activity.trace(`${adType} AdCustomizersPicker`, `${name} selected`);
        onClick(event);
        event.stopPropagation();
        event.preventDefault();
      };
      return (
        <li>
          <a
            role="menuitem"
            arial-label={description}
            href="#"
            onClick={updatedOnClick}
            key={name}
            data-index={index}
          >
            <div className="type-bold">{name}</div>
            { description ? <div className="type-normal">{description}</div> : null}
          </a>
        </li>);
    });
  }

  return (
    <ul className={classnames(classes.adCustomizerPickerEditorContainer, 'dropdown-menu', 'bypass-acccessibility-tweak', ...contentClasses)} role="menu" style={containerStyle}>
      {syntaxToUse}
      {contentView}
    </ul>
  );
}

AdCustomizerPickerEditorContainer.propTypes = {
  itemsToDisplay: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    onClick: PropTypes.func,
  })),
  syntax: PropTypes.shape({}),
  editorView: PropTypes.shape({}),
  target: PropTypes.shape({}),
  activity: PropTypes.shape({ trace: PropTypes.func }).isRequired,
  container: PropTypes.shape({ offset: PropTypes.func }),
  adType: PropTypes.string.isRequired,
};

AdCustomizerPickerEditorContainer.defaultProps = {
  itemsToDisplay: [],
  syntax: '',
  editorView: null,
  target: null,
  container: '',
};
